// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"64622704","453":"194cf566","455":"3a23009a"}[chunkId] + ".chunk.js";
};